// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"064423de","455":"bdbdf01c","977":"7eddf1e4"}[chunkId] + ".chunk.js";
};